import { Outlet, useParams, useLocation } from "react-router-dom";
import { useUniversityExists } from "@/hooks/useUniversityExists";
import { useUniversityPageTitle, getPageTitle } from "./_utils";
import UniversityNotFoundErrorBoundary from "./_components/UniversityNotFoundErrorBoundary";
import AppLayout from "@/layouts/AppLayout";

export default function UniversityLayout() {
  const { universityId } = useParams();
  const location = useLocation();

  const { universityNotFound, loading, university } = useUniversityExists(universityId);

  const universityName = university?.name;

  // Check if this is a student detail page - if so, let StudentDetailLayout handle the title
  const isStudentDetailPage =
    /\/students\/\d+\/?.*$/.test(location.pathname) && !location.pathname.includes("/upload-roster");

  const title = isStudentDetailPage
    ? null // Don't set title for student detail pages - let StudentDetailLayout handle it
    : getPageTitle(loading, universityName, "Education | University");

  useUniversityPageTitle(title);

  if (!loading && universityNotFound) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <UniversityNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  const universityProps = {
    universityName: university?.name,
    logoUrl: university?.logoUrl,
    activeStudentCount: university?.activeStudentCount,
    alumniStudentCount: university?.alumniStudentCount,
    studentProgramSummary: university?.studentProgramSummary,
    universityId: university?.id
  };

  return <Outlet context={universityProps} />;
}
